module.exports = __webpack_public_path__ + "static/media/youtube.d57a47e1.svg";